/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SavedViewDetails } from './SavedViewDetails';
import {
    SavedViewDetailsFromJSON,
    SavedViewDetailsFromJSONTyped,
    SavedViewDetailsToJSON,
} from './SavedViewDetails';

/**
 * 
 * @export
 * @interface UpsertSavedViewsRequest
 */
export interface UpsertSavedViewsRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertSavedViewsRequest
     */
    userId: number;
    /**
     * 
     * @type {Array<SavedViewDetails>}
     * @memberof UpsertSavedViewsRequest
     */
    savedViews: Array<SavedViewDetails>;
}

/**
 * Check if a given object implements the UpsertSavedViewsRequest interface.
 */
export function instanceOfUpsertSavedViewsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "savedViews" in value;

    return isInstance;
}

export function UpsertSavedViewsRequestFromJSON(json: any): UpsertSavedViewsRequest {
    return UpsertSavedViewsRequestFromJSONTyped(json, false);
}

export function UpsertSavedViewsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertSavedViewsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'savedViews': ((json['saved_views'] as Array<any>).map(SavedViewDetailsFromJSON)),
    };
}

export function UpsertSavedViewsRequestToJSON(value?: UpsertSavedViewsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.userId,
        'saved_views': ((value.savedViews as Array<any>).map(SavedViewDetailsToJSON)),
    };
}

